import React from 'react'
import { connect } from 'react-redux'
import MrtReusableTable from '../../Utils/MrtReusableTable'
import { getPoLogs } from '../../../store/Procurement/actionCreator'
import { handleFireflySendEvent } from '../../Utils/FireFlyVnextHelpers'

class PoLogReportTab extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hardwareInventoryList: [],
      loading: true,
    }
    this.baseState = { ...this.state }
  }

  async componentDidMount() {
    this.setState({ loading: true })
    await this.props.getPoLogs()
    this.setState({
      hardwareInventoryList: this.props.hardwareInventoryList,
      loading: false,
    })
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'PO Log Report',
        'PO Log Report Tab Load',
        userInfo,
      )
    }
  }

  static defaultProps = {
    userInfo: {
      email: undefined,
    },
  }
  render() {
    const columns = [
      { header: 'Year', accessorKey: 'year' },
      { header: 'PO #', accessorKey: 'po_num', size: 100 },
      {
        header: 'TTS Execution Team',
        accessorKey: 'tts_execution_team',
      },
      {
        header: 'Billing R&D PIN',
        accessorKey: 'randDPin',
      },
      {
        header: 'Qty',
        accessorKey: 'quantity',
        size: 50,
      },
      {
        header: 'Universal Part #',
        accessorKey: 'universal_part_num',
      },
      {
        header: 'Supplier',
        accessorKey: 'hardware_vendor',
      },
      {
        header: 'Part Description',
        accessorKey: 'part_description',
      },
      {
        header: 'Ship To',
        accessorKey: 'ship_to',
      },
      {
        header: 'Inventory R&D PIN',
        accessorKey: 'inventory_r_and_d_pin',
      },
      {
        header: 'Inventory Warehouse',
        accessorKey: 'inventory_warehouse',
      },
      {
        header: 'Estimated Delivery Date',
        accessorKey: 'requested_delivery_date',
      },
      {
        header: 'Qty Received',
        accessorKey: 'quantity_received',
        size: 100,
      },
      {
        header: 'Qty Outstanding',
        accessorKey: 'quantity_outstanding',
        size: 100,
      },
      {
        header: 'Hardware Received Date',
        accessorKey: 'hardware_received_date',
      },
    ]
    const defaultColumns = [
      'po_num',
      'tts_execution_team',
      'randDPin',
      'quantity',
      'universal_part_num',
      'ship_to',
      'inventory_r_and_d_pin',
      'inventory_warehouse',
      'requested_delivery_date',
      'quantity_outstanding',
      'hardware_received_date',
    ]

    return (
      <MrtReusableTable
        pageSize={[100, 200, 500]}
        pageTitle={'PO Log Report'}
        columns={columns}
        rowData={this.props.hardwareInventoryList}
        defaultColumns={defaultColumns}
        loading={this.state.loading}
        loadingMessage="Loading PO Log Report..."
      />
    )
  }
}

const mapStateToProps = (state) => ({
  hardwareInventoryList: state.procurement.hardwareInventoryList || [],
  userInfo: state.auth.userInfo,
})

const mapDispatchToProps = {
  getPoLogs,
}

export default connect(mapStateToProps, mapDispatchToProps)(PoLogReportTab)
